import { hasValue } from '@famly/stat_ts-utils_has-value';
import { isErrorNamed } from './is-error-named';
import { readServerErrorBody } from './read-server-error-body';
const retryableNetworkErrorCodes = new Set(['ECONNREFUSED', 'ETIMEDOUT', 'ENOTFOUND', 'ENETUNREACH', 'EAI_AGAIN']);
/**
 * Whether a failed request is worth retrying: a connection error, a timeout or a DNS failure,
 * rather than a response the server actually sent.
 */
export const isTransientNetworkFailure = (error) => {
    var _a, _b;
    if (!hasValue(error) || typeof error !== 'object') {
        return false;
    }
    const failure = error;
    const errorCode = (_a = failure.code) !== null && _a !== void 0 ? _a : (_b = failure.networkError) === null || _b === void 0 ? void 0 : _b.code;
    if (typeof errorCode === 'string' && retryableNetworkErrorCodes.has(errorCode)) {
        return true;
    }
    // A `ServerError` is a response the server sent, whatever its body: Apollo 3 keeps a body that
    // is not JSON as its raw text, while Apollo 4 leaves only `bodyText`, which may not parse.
    const isServerResponse = isErrorNamed(error, 'ServerError') || hasValue(readServerErrorBody(error));
    const hasGraphQLErrors = hasValue(failure.graphQLErrors) || isErrorNamed(error, 'CombinedGraphQLErrors');
    return !isServerResponse && !hasGraphQLErrors;
};
